import React from 'react';
import './styles.css';
import { Button } from 'antd';
import { FrownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const ErrorMessage = ({ message, apiError }) => {
  const [t] = useTranslation();
  return (
    <div className="error-message-container">
      <div className="icon-wrapper">
        <FrownOutlined />
      </div>
      <div className="text-wrapper">
        <h2>{message || t('nav.error.errorMessage')}</h2>
      </div>
      <div className="text-wrapper">
        {apiError ? <small>{apiError}</small> : null}
      </div>
      <div className="button-wrapper">
        <Button size="large" onClick={() => window.location.reload()}>
          {t('nav.error.buttonError')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorMessage;
